import React, { useContext, useEffect, useState } from 'react';
import styles from './ResetPass.module.scss';
import { LogoDark } from 'esa-ui-library';
import { ResetForm } from './components';
import { useStore } from '../../../common';
import { AuthContext } from '../../../logic';

const ResetPass = (): JSX.Element => {
	const [state, dispatch] = useStore(true);
	const { success } = state;
	const { logout } = useContext(AuthContext);
	const [isSuccess, setIsSuccess] = useState(false);

	useEffect(() => {
		if (success) {
			setIsSuccess(true);
		}
	}, [success]);

	const onResetSubmit = () => {
		dispatch('RESET_SUBMIT', logout);
	};

	const renderReset = () => (
		<>
			<h2>Reset Password</h2>
			{!isSuccess && <p className={styles.Explanation}>Please enter your new password.</p>}
			<ResetForm onSubmit={onResetSubmit} />
		</>
	);

	return (
		<section className={styles.Reset}>
			<section>
				<LogoDark />
				<div className={styles.ResetContent}>{renderReset()}</div>
			</section>
		</section>
	);
};

export { ResetPass };
